import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { Component, EventEmitter, Input, OnInit, Optional, Output } from '@angular/core';
import { ControlContainer, UntypedFormGroup } from '@angular/forms';
import { CallState } from '@lcs/shared/api';
import { FormsBase } from '../forms-base/forms-base';

@Component({
    selector: 'ndt-form-footer',
    templateUrl: './form-footer.component.html',
    standalone: false
})
export class FormFooterComponent implements OnInit {
   @Input() callState: CallState;

   @Input()
   get visible(): boolean {
      return this._visible;
   }

   set visible(value: boolean) {
      this._visible = coerceBooleanProperty(value);
   }

   // this will skip the form validation check on the save button in case you want to handle form save on the parent component level

   @Input() formValidityCheckOverride = false;

   @Output() cancel = new EventEmitter<void>();

   private _visible = false;

   form: UntypedFormGroup;

   constructor(private controlContainer: ControlContainer, @Optional() private formService: FormsBase) {
      if (!controlContainer) {
         throw new Error(
            'ControlContainer not found. FormFooterComponent must be placed inside an ngForm or formGroup'
         );
      }
   }

   ngOnInit(): void {
      this.form = this.controlContainer.control as UntypedFormGroup;
   }

   onSaveClick(event: MouseEvent): void {
      if (this.formValidityCheckOverride !== true) {
         if (!this.form.valid || !this.form.dirty) {
            this.form.markAllAsTouched();
            event.preventDefault();
         }

         if (this.formService) {
            this.formService.markAsSubmitted();
         }
      }
   }

   onCancelClick(): void {
      if (this.formService) {
         this.formService.markAsSubmitted(false);
      }
      this.cancel.emit();
   }
}
